import { CalendarGridBody_default } from "../Calendar/CalendarGridBody.js";
import { createBlock, defineComponent, guardReactiveProps, normalizeProps, openBlock, renderSlot, unref, withCtx } from "vue";

//#region src/DatePicker/DatePickerGridBody.vue?vue&type=script&setup=true&lang.ts
var DatePickerGridBody_vue_vue_type_script_setup_true_lang_default = /* @__PURE__ */ defineComponent({
	__name: "DatePickerGridBody",
	props: {
		asChild: {
			type: Boolean,
			required: false
		},
		as: {
			type: null,
			required: false
		}
	},
	setup(__props) {
		const props = __props;
		return (_ctx, _cache) => {
			return openBlock(), createBlock(unref(CalendarGridBody_default), normalizeProps(guardReactiveProps(props)), {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}, 16);
		};
	}
});

//#endregion
//#region src/DatePicker/DatePickerGridBody.vue
var DatePickerGridBody_default = DatePickerGridBody_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { DatePickerGridBody_default };
//# sourceMappingURL=DatePickerGridBody.js.map